import { render, staticRenderFns } from "./OrderStatusV2.vue?vue&type=template&id=d542978e&scoped=true"
import script from "./OrderStatusV2.vue?vue&type=script&lang=js"
export * from "./OrderStatusV2.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusV2.vue?vue&type=style&index=0&id=d542978e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d542978e",
  null
  
)

export default component.exports